import React from 'react';
import { ThemeProvider } from 'styled-components';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import { theme } from 'lib/styles';
import areaFormat from 'lib/areaFormat';

import Spaces from './Spaces';
import {
	BuildingImage,
	BuildingAddress,
	BuildingName,
	BuildingDetail,
	BuildingDetailsContainer,
	BuildingInfo,
	ListInfoContainer
} from './styles';

const List = props => {
	const { t, language, building } = props;
	const name = building.i18n[language].name.trim() !== '' ? building.i18n[language].name : building.address;
	const address = [building.address, building.zip_code, building.city].filter(value => value !== '' && value !== null).join(', ');
	let spaceTypes = building.spaces.map(space => space.type).filter(type => type !== null && type !== '' && typeof type !== 'undefined');

	spaceTypes = spaceTypes.filter((type, index) => spaceTypes.findIndex(_type => _type === type) === index);

	building.area = building.spaces.map(space => String(space.area).replace(/\D/g, '')).reduce((a,b) => +a + +b, 0);

	return (
		<ThemeProvider theme={theme}>
			<React.Fragment>
				<BuildingImage style={{ backgroundImage: `url(${ props.image })` }} />
				<ListInfoContainer>
					<BuildingInfo>
						<BuildingName>{name} {props.star}</BuildingName>
						<BuildingAddress>{address}</BuildingAddress>
						<BuildingDetailsContainer>

							{
								building.floors &&
								parseInt(building.floors, 10) > 0 &&
								<BuildingDetail>
								  <label>{t('browse/Building/List/Floors')}</label>
								  <p>{building.floors}</p>
								</BuildingDetail>
							}

							{
								parseInt(building.area, 10) > 0 &&
								<BuildingDetail>
								  <label>{t('browse/Building/List/Area')}</label>
								  <p>{areaFormat(building.area)} m²</p>
								</BuildingDetail>
							}

							{
								spaceTypes.length > 0 &&
								<BuildingDetail>
								  <label>{t('browse/Building/List/Space types')}</label>
								  <p>{spaceTypes.map(type => t('space-type/' + type)).join(', ')}</p>
								</BuildingDetail>
							}

							{
								building.mappedContacts &&
								building.mappedContacts.length > 0 &&
								<BuildingDetail>
								  <label>{t('browse/Building/List/Contact', { count: building.mappedContacts.length })}</label>
								  {building.mappedContacts.map(person => <p key={person.id}>{person.name}</p>)}
								</BuildingDetail>
							}

						</BuildingDetailsContainer>
					</BuildingInfo>
					{
						Array.isArray(building.spaces) &&
						<Spaces
						  spaces={building.spaces}
						  activeFilters={props.activeFilters}
						  onlyFree={props.onlyFree}
						  language={language}
						/>
					}
				</ListInfoContainer>
			</React.Fragment>
		</ThemeProvider>
	)
};

List.propTypes = {
	t: PropTypes.func,
	building: PropTypes.object,
	activeFilters: PropTypes.array,
	onlyFree: PropTypes.bool,
	star: PropTypes.element,
	image: PropTypes.string,
	language: PropTypes.oneOf(['fi','en']),
};

export default translate('translations')(List);
